<template>
    <div class="absolute inset-0 z-50 bg-black/30 rounded-2xl w-full flex justify-center items-center">

        <div
            class="w-full h-full lg:w-2/3 lg:h-5/6 flex flex-col items-center lg:p-5 justify-center bg-white rounded-2xl">
            <div class="w-2/3 lg:h-3/4 flex flex-col justify-center ">
                <img src="../../assets/cancelVictor.png" alt="">
            </div>
      
            <div class="lg:h-1/4 w-3/4 flex flex-col justify-center mt-5 lg:mt-0">
                <div class=" text-white bg-red-500 py-2 px-3 rounded-lg w-fit font-medium mx-auto my-3 animate-pulse">{{ $t('order_canceled_header') }}</div>
                <div class="text-center text-gray-800 )">{{ $t('order_canceled_message') }}</div>
            </div>
        </div>
    </div>
</template>